import { ref } from 'vue';

/**
 * Small utility for toggling a value between true and false
 *
 * @param {*} initValue initial value
 * @returns method and toggle value
 */
export default function (initValue = false) {
  const toggleValue = ref(initValue);

  /**
   * Toggle from true->false and vice versa
   */
  function toggle() {
    toggleValue.value = !toggleValue.value;
  }

  /**
   * Force a value (true|false)
   * @param value true|false
   */
  function set(value: boolean) {
    toggleValue.value = value;
  }

  return { toggleValue, toggle, set };
}
